import { useEffect } from "react";
import Lottie from "lottie-react";
import lottieAnim from "../../../assets/lottie/rediger_del_klip.json";

export default function PersonligeFraser({
  pauseAll,
  lottieRef,
  htmlRef,
}: {
  pauseAll: (lottieRef: any) => void;
  lottieRef: any;
  htmlRef: any;
}) {
  useEffect(() => {
    const playVideoWhenInView = (entries: IntersectionObserverEntry[]) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          pauseAll(lottieRef);
          lottieRef.current?.play();
        } else {
          lottieRef.current?.pause();
        }
      });
    };

    const options = {
      root: null,
      rootMargin: "0px",
      threshold: 1,
    };

    const observer = new IntersectionObserver(playVideoWhenInView, options);

    if (htmlRef.current) {
      observer.observe(htmlRef.current);
    }

    return () => {
      observer.disconnect();
    };
  }, [htmlRef, lottieRef, pauseAll]);

  return (
    <div className="mx-auto grid grid-cols-1 border-b md:border-none md:grid-cols-2 mx-auto items-center md:py-32 gap-4 items-start container pb-[15px] md:pb-[40px] mb-8 md:pb-0">
      <div className="flex order-1 md:container md:order-1 justify-center">
        <div ref={htmlRef} className="player w-full">
          <Lottie
            animationData={lottieAnim}
            autoplay={false}
            loop={true}
            lottieRef={lottieRef}
            className="player"
          />
        </div>
      </div>
      <div className="mb-6 md:mb-0 md:container order-1 md:order-2">
        <h2 className="text-dxl md:text-d2xl font-bold text-doctio-green">
          Personlige fraser og delefunktion
        </h2>
        <p className="">
          Måden at journalføre på er en faglig præference og et skøn. Derfor har
          vi gjort det muligt at tilpasse fraserne til dit behov. Hos Doctio har
          du mulighed for at bruge det eksisterende frasebibliotek, oprette dine
          egne fraser fra bunden eller redigere i det eksisterende
          frasebibliotek.
          <br></br>
          Med Doctio Pros administationsmodul har du mulighed for at dele fraser
          med dine kollegaer, på tværs af forskellige klinikker eller
          afdelinger. Du kan også tildele forskellige brugerrettigheder når
          fraserne deles. Det gør det nemt at være flere om at holde fraserne
          ajourførte (f.eks. i en klinik eller klynge) og delte fraser
          synkroniseres automatisk på tværs af brugerne.
        </p>
        <a href="/signup" className="text-doctio-green font-bold">
          Opret dig som Doctio Pro bruger
        </a>
      </div>
    </div>
  );
}
